import { attachPropertiesToComponent } from '../../../utils/attach-properties-to-component'
import { Popover } from './popover'

export default attachPropertiesToComponent(Popover, {
})
